export function formatFulfilmentDates(dates: string): string {
	let date: Date;
	if (dates.split('-').length > 2) {
		date = new Date(dates);
	} else {
		date = new Date(
			new Date().getFullYear(),
			parseInt(dates.split('-')[0]) - 1,
			parseInt(dates.split('-')[1])
		);
	}
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric'
	};
	return date.toLocaleDateString('en-IE', options);
}
